module.exports = "/_next/static/images/7b9347f63927c8b3784262f19713cb31-slide-1-large.png.webp";